export { getLegalDocumentBody };

function getLegalDocumentBody(html: string): string {
  const bodyTagString = html.match(new RegExp('<body.*?>'))[0];
  const startIndex = html.indexOf(bodyTagString) + bodyTagString.length;
  const endIndex = html.match(new RegExp('</body>')).index;
  return html.substring(startIndex, endIndex);
}
